<template>
  <div class="containerBox"  ref="box">
    <!--  顶部导航  -->
    <nav-bar />
    <!--  轮播图  -->
    <banner-list :banner-list="bannerList" />
    <!--  优势  -->
    <div class="box1">
      <div class="container dis" style="height: 100%;">
        <div class="box1_left" v-scroll-reveal="{origin: 'left'}">
          <div class="title1">为企业量身打造全渠道一站式服务平台</div>
          <div class="border"></div>
          <p>打通各个环节、让物流一体化、从发布货源到货物配送，提供完整的解决方案，货主通过货主端发布货源，司机通过司机端进行配送，操作简单</p>
          <div class="title1" style="margin-top: 70px;">助力企业降低成本获取数字化核心竞争力</div>
          <div class="border"></div>
          <p>高效整合货运资源、信息化能力、数字化转型快速盈利、技术与数据支持</p>
        </div>
        <div class="box1_right" v-scroll-reveal="{origin: 'right'}">
          <div class="box1_right_item1">
            <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/box3.png" alt="">
            <p>数字化转型快速盈利</p>
          </div>
          <div class="box1_right_item2">
            <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/box1.png" alt="">
            <p style="margin-bottom: 0px;">信息化能力</p>
            <p>高效整合货运资源</p>
          </div>
          <div class="box1_right_item3">
            <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/box2.png" alt="">
            <p>技术与数据支持</p>
          </div>
        </div>
      </div>
    </div>
    <!--  产品优势  -->
    <div class="advantage">
      <div class="container">
        <div class="title" v-scroll-reveal>产品优势</div>
        <div class="title_border" v-scroll-reveal></div>
        <div class="advantage_box" v-scroll-reveal="{origin: 'bottom'}">
          <div class="box_item">
            <img class="box_item_left" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/advantage1.png" alt="">
            <div class="box_item_right">
              <p class="box_item_right_title">资质优势</p>
              <p class="box_item_right_content">平台提供合规、合法的发票。并为企业提供解决方案</p>
            </div>
          </div>
          <div class="box_item">
            <img class="box_item_left" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/advantage2.png" alt="">
            <div class="box_item_right">
              <p class="box_item_right_title">综合优势</p>
              <p class="box_item_right_content">多端操作，几十万运力数据，可根据企业需求制定适合的个性化服务</p>
            </div>
          </div>
          <div class="box_item">
            <img class="box_item_left" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/advantage3.png" alt="">
            <div class="box_item_right">
              <p class="box_item_right_title">功能全面</p>
              <p class="box_item_right_content">运输全流程系统，支持物流企业、生产制造业等多种业务模式实现物流的高效协同</p>
            </div>
          </div>
        </div>
        <div class="advantage_box" style="margin-top: 40px;" v-scroll-reveal="{origin: 'bottom'}">
          <div class="box_item">
            <img class="box_item_left" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/advantage4.png" alt="">
            <div class="box_item_right">
              <p class="box_item_right_title">透明化运输</p>
              <p class="box_item_right_content">运输全流程监管，从接单到运输结束每个流程均可在线查询公开透明</p>
            </div>
          </div>
          <div class="box_item">
            <img class="box_item_left" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/advantage5.png" alt="">
            <div class="box_item_right">
              <p class="box_item_right_title">安全保障</p>
              <p class="box_item_right_content">严格审核用户信息，保险加持保障货物运输安全，消除用户后顾之忧</p>
            </div>
          </div>
          <div class="box_item">
            <img class="box_item_left" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/advantage6.png" alt="">
            <div class="box_item_right">
              <p class="box_item_right_title">增值服务</p>
              <p class="box_item_right_content">满足物流各种场景需求，包括发票、ETC、轨迹、加油、保险等提供全方位的优质服务</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  了解我们的产品  -->
    <div class="learn container">
      <div class="title" style="color: #333333" v-scroll-reveal>了解我们的产品</div>
      <div class="title_border" v-scroll-reveal></div>
      <div class="learnBox">
        <img v-scroll-reveal="{origin: 'left'}" class="learn_left" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/learn_bg.png" alt="">
        <div class="learn_right" v-scroll-reveal="{origin: 'right'}">
          <div class="learn_right_title">货主端</div>
          <div class="learn_right_content">货主根据货源的运输需求，在平台发布货源信息，通过平台完成货物运输的同时，平台也可以代开增值税发票</div>
          <div class="learn_right_btn" @click="goUrl('/serve-serveshipper')">查看详情 <span style="margin-left: 10px;">→</span></div>
        </div>
      </div>
    </div>
    <div class="learn2">
      <div class="container dis" style="height: 100%;">
        <div class="learnBox">
          <div class="learn_right"  v-scroll-reveal="{origin: 'left'}">
            <div class="learn_right_title">司机端</div>
            <div class="learn_right_content">司机可直观的查看货源信息、实现在线接单、签约并支持其他增值服务，解决司机直观需求</div>
            <div class="learn_right_btn"  @click="goUrl('/serve-servedriver')">查看详情 <span style="margin-left: 10px;">→</span></div>
          </div>
          <img class="learn_left" style="margin-top: 320px" v-scroll-reveal="{origin: 'right'}" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/box2_icon.png" alt="">
        </div>
      </div>
    </div>
    <div class="learn3 container" v-scroll-reveal="{origin: 'left'}">
      <div class="learnBox">
        <img class="learn_left" v-scroll-reveal="{origin: 'left'}" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/box3_bg.png" alt="">
        <div class="learn_right" v-scroll-reveal="{origin: 'right'}">
          <div class="learn_right_title">平台端</div>
          <div class="learn_right_content">强大的数据支持，实时跟进订单流程。对角色认证进行严谨的审核保证每个订单完成。提高工作效率</div>
        </div>
      </div>
    </div>
    <!--  底部  -->
    <bottom-footer/>
    <!--  悬浮按钮  -->
    <fix-anchor @goBottom="goBottom" />
  </div>
</template>

<script>
import NavBar from '@/components/nav-bar.vue'
import BannerList from '@/components/banner-list.vue'
import BottomFooter from '@/components/bottom-footer.vue'
import FixAnchor from '@/components/fix-anchor.vue'
import 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: "ProductServe",
  components: {
    NavBar,
    BannerList,
    BottomFooter,
    FixAnchor,
  },
  data() {
    return{
      bannerList: [{coverImgUrl: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/banner/serve_banner.png'}],
    }
  },
  created() {
    // this.$public.getBanner(8, 0).then(res=>{
    //   this.bannerList = res.data.rows
    // })
  },
  methods: {
    /**
     * @description: 页面滚动到顶部
     * @author: 书童
     */
    goBottom() {
      let top = this.$refs.box.offsetHeight, scrollTop = document.documentElement.scrollTop, clientHeight = document.documentElement.clientHeight
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = scrollTop += 50
        if (top <= (scrollTop + clientHeight)) {
          clearInterval(timeTop)
        }
      }, 10)
    },
    /**
     * @description: 跳转路径
     * @author: 书童
     */
    goUrl(url) {
      this.$router.push({
        path: url
      })
    }
  },
  mounted() {
    if (this.$public.isMobile()) {
      window.location.href = 'http://hmmwuliu.net/common/ws-m/productServe.html'
    }
  }
}
</script>

<style scoped lang="scss">
.title{
  font-size: 30px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  text-align: center;
  color: #FFFFFF;
  line-height: 42px;
  margin-top: 70px;
}
.title_border{
  width: 40px;
  height: 2px;
  background: #f39801;
  margin: 6px auto 0;
}
.dis{
  display: flex;
  justify-content: space-between;
}
.box1{
  height: 679px;
  width: 100%;
  padding: 70px 0;
  box-sizing: border-box;
  //background-color: #fff;
  .box1_left{
    width: 465px;
    height: 100%;
    .title1{
      font-size: 20px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: #333333;
      line-height: 28px;
      margin-top: 119px;
    }
    .border{
      width: 40px;
      height: 2px;
      background: #f39801;
      margin-top: 6px;
    }
    p{
      width: 346px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: #555555;
      line-height: 20px;
      margin-top: 30px;
    }
  }
  .box1_right{
    position: relative;
    width: 736px;
    height: 100%;
    .box1_right_item1{
      position: absolute;
      left: 0;
      top: 55px;
      width: 340px;
      height: 350px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      z-index: 2;
      p{
        position: relative;
        line-height: 30px;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: left;
        color: #ffffff;
        padding: 0 30px;
        box-sizing: border-box;
        margin-bottom: 30px;
        z-index: 2;
      }
      &>img{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
      }
    }
    .box1_right_item2{
      position: absolute;
      left: 309px;
      top: 199px;
      width: 278px;
      height: 340px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      z-index: 3;
      p{
        position: relative;
        line-height: 30px;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: left;
        color: #ffffff;
        padding: 0 30px;
        box-sizing: border-box;
        margin-bottom: 30px;
        z-index: 3;
      }
      &>img{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
      }
    }
    .box1_right_item3{
      position: absolute;
      left: 372px;
      top: 0px;
      width: 364px;
      height: 246px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      z-index: 4;
      p{
        position: relative;
        line-height: 30px;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: left;
        color: #ffffff;
        padding: 0 30px;
        box-sizing: border-box;
        margin-bottom: 30px;
        z-index: 4;
      }
      &>img{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 3;
      }
    }
  }
}
.advantage{
  overflow: hidden;
  width: 100%;
  height: 526px;
  background: url("https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/advantage_bg.png");
  .advantage_box{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 130px;
    margin-top: 50px;
    .box_item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 346px;
      height: 120px;
      padding: 0 20px;
      background: rgba(255,255,255,0.90);
      border-radius: 10px;
      box-shadow: 0px 2px 10px 2px rgba(0,0,0,0.05);
      //box-sizing: border-box;
      .box_item_left{
        display: block;
        width: 70px;
        height: 66px;
        margin-right: 20px;
      }
      .box_item_right{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .box_item_right_title{
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #333333;
          line-height: 22px;
          margin-bottom: 10px;
        }
        .box_item_right_content{
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #666666;
          line-height: 20px;
        }
      }
    }
    .box_item:hover{
      border-bottom: 6px solid #4E9BFF;
    }
  }
}
.learn{
  height: 786px;
  overflow: hidden;
  .learnBox{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 674px;
    .learn_left{
      display: block;
      width: 757px;
      height: 674px;
    }
    .learn_right{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      .learn_right_title{
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 28px;
      }
      .learn_right_content{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 22px;
        margin-top: 30px;
        margin-bottom: 40px;
      }
      .learn_right_btn{
       width: 145px;
       height: 41px;
       border: 1px solid #4e9bff;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #4e9bff;
        line-height: 41px;
        letter-spacing: 0.16px;
        cursor: pointer;
      }
      .learn_right_btn:hover{
        background-color: #4e9bff;
        color: #FFFFFF;
      }
    }
  }
}
.learn3{
  hieght: 584px;
  padding: 50px 0;
  box-sizing: border-box;
  .learnBox{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 484px;
    .learn_left{
      display: block;
      width: 617px;
      height: 484px;
      margin-right: 13px;
    }
    .learn_right{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 488px;
      .learn_right_title{
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 28px;
      }
      .learn_right_content{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 22px;
        margin-top: 30px;
      }
    }
  }
}
.learn2{
  height: 616px;
  width: 100%;
  background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/box2_bg.png');
  background-size: 100%;
  .learnBox{
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 616px;
    .learn_left{
      display: block;
      width: 505px;
      height: 925px;
    }
    .learn_right{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 488px;
      margin-right: 68px;
      .learn_right_title{
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #FFFFFF;
        line-height: 28px;
      }
      .learn_right_content{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #FFFFFF;
        line-height: 22px;
        margin-top: 30px;
        margin-bottom: 40px;
      }
      .learn_right_btn{
        width: 145px;
        height: 41px;
        border: 1px solid #FFFFFF;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #FFFFFF;
        line-height: 41px;
        letter-spacing: 0.16px;
        cursor: pointer;
      }
      .learn_right_btn:hover{
        border: 1px solid #4E9BFF;
        background-color: #4E9BFF;
        color: #FFFFFF;
      }
    }
  }
}
</style>